// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"231":"b8ecfd9f","257":"4ef83703","396":"8b9d42bd","453":"d5bed59f","666":"c62d52f4","900":"ec44d338"}[chunkId] + ".chunk.js";
};